exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PrimaryIcon__favoriteIcon___2W8yZ {\n  width: 22px;\n  height: 19.6px;\n  display: inline-block;\n  cursor: pointer;\n  filter: drop-shadow(0px 1px 2px #8c8c8c);\n  transition: 300ms; }\n  .PrimaryIcon__favoriteIcon___2W8yZ .PrimaryIcon__heartFill___1yte2 {\n    fill: rgba(255, 255, 255, 0);\n    transition: fill 300ms; }\n  .PrimaryIcon__favoriteIcon___2W8yZ:hover .PrimaryIcon__heartFill___1yte2 {\n    fill: rgba(255, 255, 255, 0.5); }\n  .PrimaryIcon__favoriteIcon___2W8yZ.PrimaryIcon__isFavorite___1Wb7c .PrimaryIcon__heartFill___1yte2 {\n    fill: #FFF; }\n", ""]);

// exports
exports.locals = {
	"favoriteIcon": "PrimaryIcon__favoriteIcon___2W8yZ",
	"heartFill": "PrimaryIcon__heartFill___1yte2",
	"isFavorite": "PrimaryIcon__isFavorite___1Wb7c"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/FavoriteButtonWhite/styles/PrimaryIcon.scss
// module id = 3938
// module chunks = 6